// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2mbYw","bigColWidth":"Table_bigColWidth__179t7","biggerColWidth":"Table_biggerColWidth__10Spb","row":"Table_row__1nJXu","col":"Table_col__2Pan8"};